// src/components/album-carousel/album-carousel.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    icon {\n      id\n      size\n      title\n    }\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment TripsAlbumCardFragment on TripsAlbumCard {\n    primary\n    secondaries\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n    }\n    icons {\n      icons {\n        id\n        token\n        description\n      }\n      label\n    }\n    impressionTracking {\n      linkName\n      referrerId\n    }\n    image {\n      url\n      description\n    }\n    button {\n      primary\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment TripsCarouselFragment on TripCarousel {\n    accessibilityHeader\n    header\n    nextButton {\n      accessibility\n    }\n    prevButton {\n      accessibility\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    peek\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query SharedUIWeb_TripsAlbumCarouselQuery($context: ContextInput!) {\n    tripsCollection(context: $context) {\n      tripsAlbumCarousel {\n        carousel {\n          ...TripsCarouselFragment\n        }\n        content {\n          ...TripsAlbumCardFragment\n        }\n        moreInfoLink {\n          ...EGDSStandardLinkFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/album-carousel/__private/__fragments/egds-standard-link.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var EGDSStandardLink = function(param) {
    var data = param.data;
    var action = data.action, text = data.text, icon = data.icon;
    var accessibility = action.accessibility, analytics = action.analytics;
    var clickTracker = useClickTracker();
    var onClickCapture = function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    };
    var _icon_title;
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkLink, null, /* @__PURE__ */ React.createElement("a", {
        href: action.resource.value,
        onClickCapture: onClickCapture
    }, text, icon && /* @__PURE__ */ React.createElement(UitkIcon, {
        name: icon.id,
        size: icon.size ? UitkIconSize[icon.size] : void 0,
        title: (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : void 0
    }), accessibility && /* @__PURE__ */ React.createElement(UitkText, {
        className: "is-visually-hidden"
    }, accessibility))));
};
EGDSStandardLink.fragment = fragment;
EGDSStandardLink.displayName = "TripsCarousel";
// src/components/album-carousel/__private/__fragments/trips-album-card.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText2 } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var TripsAlbumCard = function(props) {
    var data = props.data, showDesktopCard = props.showDesktopCard, desktopFigureRatio = props.desktopFigureRatio, lazyLoadImage = props.lazyLoadImage;
    var primary = data.primary, secondaries = data.secondaries, image = data.image, icons = data.icons, action = data.action, impressionTracking = data.impressionTracking, button = data.button;
    var clickTracker = useClickTracker2();
    var onClickCapture = function() {
        return clickTracker(action.analytics.referrerId, action.analytics.linkName);
    };
    var iconsGroup = icons === null || icons === void 0 ? void 0 : icons.map(function(iconGroup, index) {
        return /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
            key: "trip-album-card-icons-group-".concat(index)
        }, iconGroup.icons.map(function(icon, iconIndex) {
            return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
                key: "trip-album-card-icon-".concat(iconIndex),
                padding: {
                    inlineend: "one"
                }
            }, /* @__PURE__ */ React2.createElement(UitkIcon2, {
                key: icon.id,
                name: icon.id,
                theme: "default",
                size: UitkIconSize2.SMALL
            }));
        }), /* @__PURE__ */ React2.createElement(UitkText2, {
            size: 300
        }, iconGroup.label));
    });
    var secondaryGroup = secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function(secondary, index) {
        return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            padding: {
                blockstart: "two"
            },
            key: "secondary-".concat(index)
        }, /* @__PURE__ */ React2.createElement(UitkText2, {
            size: 300
        }, secondary));
    });
    var cardDetails = /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkHeading, {
        tag: "h4",
        size: 4
    }, primary), secondaryGroup, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        space: "three",
        wrap: "wrap"
    }, iconsGroup)));
    var _action_accessibility;
    var cardLink = /* @__PURE__ */ React2.createElement(UitkCardLink, null, /* @__PURE__ */ React2.createElement("a", {
        href: action.resource.value,
        onClickCapture: onClickCapture
    }, (_action_accessibility = action.accessibility) !== null && _action_accessibility !== void 0 ? _action_accessibility : ""));
    var defaultCard = /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        blockSize: "full_size",
        columns: 1
    }, /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, {
        colSpan: 1
    }, /* @__PURE__ */ React2.createElement("div", null, cardLink, /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: desktopFigureRatio ? UitkFigureAspectRatioType.R16_9 : UitkFigureAspectRatioType.R3_2
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        alt: image === null || image === void 0 ? void 0 : image.description,
        src: image === null || image === void 0 ? void 0 : image.url,
        placeholderImage: true,
        lazyLoading: lazyLoadImage ? "lazy" : "off"
    })), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: "four"
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection, null, cardDetails)))));
    var desktopCard = /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        columns: 10,
        rows: [
            "70x"
        ]
    }, /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, {
        colSpan: 6
    }, /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        alt: image === null || image === void 0 ? void 0 : image.description,
        src: image === null || image === void 0 ? void 0 : image.url,
        placeholderImage: true,
        lazyLoading: lazyLoadImage ? "lazy" : "off"
    }))), /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, {
        colSpan: 4
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: false
    }, !button && cardLink, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        blockSize: "full_size",
        justifyContent: "center",
        direction: "column"
    }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, cardDetails, button && /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSecondaryButton, {
        href: action.resource.value,
        onClick: onClickCapture
    }, button.primary)))))))));
    return /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: impressionTracking.referrerId,
        linkName: impressionTracking.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, /* @__PURE__ */ React2.createElement(UitkCard, {
        border: true
    }, defaultCard))), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        grow: 1,
        minWidth: "zero"
    }, /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: impressionTracking.referrerId,
        linkName: impressionTracking.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, /* @__PURE__ */ React2.createElement(UitkCard, {
        border: true
    }, showDesktopCard ? desktopCard : defaultCard)))));
};
TripsAlbumCard.fragment = fragment2;
TripsAlbumCard.displayName = "TripsCarousel";
// src/components/album-carousel/__private/__fragments/trips-carousel.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var fragment3 = gql3(_templateObject2());
var TripsCarousel = function(props) {
    var data = props.data, children = props.children, hasThreeOrLessTrips = props.hasThreeOrLessTrips, carouselHeadingSize = props.carouselHeadingSize;
    var header = data.header, nextButton = data.nextButton, prevButton = data.prevButton, analytics = data.analytics;
    var track = useClickTracker3();
    var carouselProps = {
        carouselName: "TripsAlbumCarousel",
        analytics: {
            id: analytics.referrerId,
            description: analytics.linkName,
            callback: function(referrerId, linkName) {
                track(referrerId, linkName);
            }
        },
        buttonText: {
            nextButton: nextButton.accessibility,
            prevButton: prevButton.accessibility
        },
        itemsVisible: {
            sm: 1,
            md: 3,
            lg: 3
        },
        itemsMaxHeight: true,
        pageBy: 1,
        peek: true,
        children: children
    };
    return /* @__PURE__ */ React3.createElement(Viewport2, null, /* @__PURE__ */ React3.createElement(ViewSmall2, null, /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkHeading2, {
        tag: "h3",
        size: carouselHeadingSize !== null && carouselHeadingSize !== void 0 ? carouselHeadingSize : 5
    }, header), /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React3.createElement(UitkCarousel, _object_spread({}, carouselProps), children)))), /* @__PURE__ */ React3.createElement(ViewMedium2, null, /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkHeading2, {
        tag: "h3",
        size: carouselHeadingSize !== null && carouselHeadingSize !== void 0 ? carouselHeadingSize : 4
    }, header), /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            blockstart: "six"
        }
    }, hasThreeOrLessTrips ? /* @__PURE__ */ React3.createElement(UitkLayoutFlex2, {
        direction: "row",
        space: "three"
    }, children) : /* @__PURE__ */ React3.createElement(UitkCarousel, _object_spread({}, carouselProps), children)))));
};
TripsCarousel.fragment = fragment3;
TripsCarousel.displayName = "TripsCarousel";
// src/components/album-carousel/album-carousel.tsx
var __Query = gql4(_templateObject3(), TripsCarousel.fragment, TripsAlbumCard.fragment, EGDSStandardLink.fragment);
var AlbumCarousel = function(props) {
    var skipSsr = props.skipSsr, carouselHeadingSize = props.carouselHeadingSize, lazyLoadImage = props.lazyLoadImage;
    var context = useBexApi().context;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var tripsAlbumCarousel = data === null || data === void 0 ? void 0 : data.tripsCollection.tripsAlbumCarousel;
    if (loading || error || !tripsAlbumCarousel || !tripsAlbumCarousel || tripsAlbumCarousel.content.length <= 0) {
        return null;
    }
    var singleTrip = tripsAlbumCarousel.content.length === 1;
    var threeOrLessTrips = tripsAlbumCarousel.content.length <= 3;
    return /* @__PURE__ */ React4.createElement(Viewport3, null, /* @__PURE__ */ React4.createElement(ViewSmall3, null, /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(TripsCarousel, {
        data: tripsAlbumCarousel.carousel,
        carouselHeadingSize: carouselHeadingSize
    }, tripsAlbumCarousel.content.map(function(card, index) {
        return /* @__PURE__ */ React4.createElement(TripsAlbumCard, {
            key: "".concat(index, "-").concat(card.primary),
            data: card,
            lazyLoadImage: lazyLoadImage
        });
    })), !singleTrip && tripsAlbumCarousel.moreInfoLink && /* @__PURE__ */ React4.createElement(EGDSStandardLink, {
        data: tripsAlbumCarousel.moreInfoLink
    }))), /* @__PURE__ */ React4.createElement(ViewMedium3, null, /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(TripsCarousel, {
        data: tripsAlbumCarousel.carousel,
        hasThreeOrLessTrips: threeOrLessTrips,
        carouselHeadingSize: carouselHeadingSize
    }, tripsAlbumCarousel.content.map(function(card, index) {
        return /* @__PURE__ */ React4.createElement(TripsAlbumCard, {
            key: "".concat(index, "-").concat(card.primary),
            data: card,
            showDesktopCard: singleTrip,
            desktopFigureRatio: threeOrLessTrips,
            lazyLoadImage: lazyLoadImage
        });
    })), !singleTrip && tripsAlbumCarousel.moreInfoLink && /* @__PURE__ */ React4.createElement(EGDSStandardLink, {
        data: tripsAlbumCarousel.moreInfoLink
    }))));
};
AlbumCarousel.displayName = "sharedui-AlbumCarousel";
export { AlbumCarousel };
//# sourceMappingURL=index.js.map